
import React, { FC } from 'react';
import styled from '@emotion/native';
import Card from '@components/1-atoms/Card';
import { Row, Text, Spacer } from '@components/1-atoms';
import { Button } from '@components/2-molecules';
import { NavigationProp } from '@react-navigation/native';

import HandingDocument from '@assets/handing-document-illustration'


const Content = styled.View``;

const Background = styled.View`
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    
    margin: -12px;
`;

type Props = {};

const WelcomeDocumentTemplate: FC<Props> = ({  }) => {

    return (
        <Card>
            <Background>
                <HandingDocument />
            </Background>

            <Content>
                <Row>
                    <Text large>Welcome 👋</Text>
                </Row>
                <Spacer h={1.5} />

                <Row>
                    <Text contrasted>
                        First things, first ..!{'\n'}
                        Create a business profile, and start issuing business documents in no time. A chart of accounts and an exempt tax item will be generated for you.
                    </Text>
                </Row>
                <Spacer h={2} />

            </Content>
        </Card>
    );

};

export default WelcomeDocumentTemplate;
